import React, { ComponentType, ReactNode } from 'react'
import { Theme } from 'src/ui/style/Theme'
import { css } from 'src/ui/style/css'
import { useTheme } from 'src/ui/style/useTheme'

type Level = 1 | 2 | 3

const getFontSize = (level: Level) => {
    const th = useTheme()
    let fontSize = th.fontSize.md
    switch (level) {
        case 1:
            fontSize = th.fontSize.xl
            break
        case 2:
            fontSize = th.fontSize.lg
            break
        case 3:
            fontSize = th.fontSize.md
            break
        default:
            throw new Error('Unsupported level of Heading')
    }
    return fontSize
}

export type HeadingProps = {
    level: Level
    children: ReactNode
    className?: string
    fontSize?: string
}

type HeadingTag = 'h1' | 'h2' | 'h3'

export const Heading: ComponentType<HeadingProps> = ({
    level,
    children,
    fontSize,
    className
}) => {
    const Comp = `h${level}` as HeadingTag
    const fs = fontSize || getFontSize(level)
    return (
        <Comp
            className={className}
            css={(th: Theme) => [
                css`
                    font-weight: ${th.fontWeight.bold};
                    font-size: ${fs};
                `
            ]}
        >
            {children}
        </Comp>
    )
}
